import * as _ from 'lodash-es'
import { luxNow } from '../../sharedF/timeF/luxon0NowF.mts'
import { useState, useEffect, useMemo } from 'react'
import { throwIf } from '../../sharedF/throwErrorF/throwIfF.mts'

export const useNow = ({tickPeriod=1000, nowGetter=() => luxNow()}={}) => {

  throwIf(() => !_.isInteger(tickPeriod), {tickPeriod})

  const [tickNo, setTickNo] = useState(0)
  const tick = () => {
    setTickNo(tickNo + 1)
  }

  const now = useMemo(nowGetter, [tickNo])

  useEffect(() => {
    const ii = setTimeout(tick, tickPeriod)

    return () => {
      clearTimeout(ii)
    }
  }, [tickNo])

  return {now, tickNo, elapsed: tickNo * tickPeriod}
}